// 定义 EventBus, 方便模块快速集成事件能力
// 【不使用全局的 EventBus】，避免隐式打破模块间的依赖关系
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var _listeners;
// TODO: EventBus 不准确，重命名为 EventTool
export class EventBus {
    constructor() {
        _listeners.set(this, new Map());
        /**
         * 监听EventType中定义的事件，调用方【必须】在合适的时机自行移除监听
         */
        this.on = (type, handler) => {
            var _a;
            const handlers = (_a = __classPrivateFieldGet(this, _listeners).get(type)) !== null && _a !== void 0 ? _a : new Set();
            handlers.add(handler);
            if (!__classPrivateFieldGet(this, _listeners).has(type)) {
                __classPrivateFieldGet(this, _listeners).set(type, handlers);
            }
            return () => {
                handlers.delete(handler);
                if (handlers.size === 0) {
                    __classPrivateFieldGet(this, _listeners).delete(type);
                }
            };
        };
        /**
         * 触发事件
         * @param type
         * @param args
         * @returns
         */
        this.emit = (type, ...args) => {
            const handlers = __classPrivateFieldGet(this, _listeners).get(type);
            if (handlers == null)
                return;
            handlers.forEach((handler) => handler(...args));
        };
    }
    /**
     * 在两个 EventBus 实例间转发消息
     * @param from
     * @param to
     * @param evtTypes 需转发的消息类型
     * @returns
     */
    static forwardEvent(from, to, 
    // 转发的事件名，如果 evtTypes 为序对（元组）表示事件名称需要映射
    evtTypes) {
        const removeHandlers = evtTypes.map((evtType) => {
            const [fromEvtType, toEvtType] = Array.isArray(evtType) ? evtType : [evtType, evtType];
            return from.on(fromEvtType, (...args) => to.emit(toEvtType, ...args));
        });
        return () => {
            removeHandlers.forEach(fn => fn());
        };
    }
    getHandlers(type) {
        var _a;
        return (_a = __classPrivateFieldGet(this, _listeners).get(type)) !== null && _a !== void 0 ? _a : new Set();
    }
    /**
     * 监听事件，首次触发后自动移除监听
     * 期望回调一次的事件，使用once; 期望多次回调使用on
     */
    once(type, handler) {
        const off = this.on(type, (...args) => {
            off();
            handler(...args);
        });
        return off;
    }
    destroy() {
        __classPrivateFieldSet(this, _listeners, new Map());
    }
}
_listeners = new WeakMap();
//# sourceMappingURL=event-bus.js.map